module.exports = __webpack_public_path__ + "static/media/ta-pro-02.40968ead.png";